
import "../App.css";
import { Link } from 'react-router-dom'
import moment from 'moment';


import React, {
  useState,
  useEffect
} from 'react';
import dayjs from 'dayjs'

import {
  SearchOutlined,
} from '@ant-design/icons';

import {
  message,
  Form,
  Input,
  Popconfirm,
  Typography,
  DatePicker,
  InputNumber,
  Divider,
  Button,
  Table
} from "antd"

import {
  db,
  storr
} from '../firebase/firebase'



const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const Events = () => {
  useEffect(() => {
    pullFromDB()
  }, []);

  const [form] = Form.useForm();
  const [data, setData] = useState(data);
  const [editingKey, setEditingKey] = useState('');
  const [pendingData, setPendingData] = useState({ disabled: true, inputDisabled: false });
  const [disabled, setDisabled] = useState(true);
  const [addingEvent, setAddingEvent] = useState(false);
  const [pendingTitle, setPendingTitle] = useState('');
  const [pendingDate, setPendingDate] = useState(moment());
  const [addingTodo, setAddingTodo] = useState('');

  //   data: [],
  //   editingKey: '',
  //   da: null,
  //   ta: null,

  const exportTime = (x) => {
    // var a = x.format("DD-MM-YYYY");
    var a = x.format("YYYY-MM-DD");
    return a;
  }

  const handleChange = (date) => {
    setPendingDate(date)
  }

  const importTime = (s) => {
    var v = new Date(s);
    return v.toLocaleString();
  }

  const deleteTheEvent = async (key) => {
    await db
      .collection("events")
      .doc(data[key].id)
      .delete().then(function () {
        message.success("Event deleted successfully")
      }).catch(function (error) {
        message.error(error.message)
      });
  }


  //todo: use another field 'number of media' to do instead of setting up another snapshot
  const deleteEntry = async (keyo) => {
    await db.collection("eventmedias").where("event", "==", data[keyo].id).get().then(snapshot => {
      if (snapshot.empty) {
        deleteTheEvent(keyo);
      } else {
        message.error("Delete the associating media first")
      }
    })
  }


  const addEvent = async () => {
    //if no title, prohibit adding new event
    if (!pendingTitle) return;

    // Set a flag to indicate loading
    setAddingEvent(true)
    
    // Add a new event from the value of the input
    // console.log("adding event titled: ", pendingTitle)
    try {
      
      let response = await db.collection("events").add({
        timestamp: Date.now(),
        date: exportTime(pendingDate),
        title: pendingTitle,
      })
      message.success("Event successfully added!");
      
    } catch (error) {
      message.error(error.message);
    }
    
    // Remove the loading flag and clear the input
    setAddingEvent(false)
    setPendingTitle('')
    setPendingDate(moment())
  }

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    console.log('ff')
    form.setFieldsValue({
      filename: '',
      startdate: '',
      ...record,
    });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });

        try {

          let rr = await db
            .collection("events")
            .doc(data[index].id).update({
              //to do in the future: maybe convert the user editted date into isostring format, so can store together
              // date: this.state.da,
              title: newData[index].title
            })
          message.success("Event " + newData[index].title + " successfully updated!");
          setData(newData)
          setEditingKey('');

        } catch (error) {
          message.error(error.message);

        }

      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  }

  const toLocalTime = (ts) => {
    var dt = new Date(ts).toLocaleString();
    return dt
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
          </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
          </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      text
    ),
  })
  const pullFromDB = () => {

    db.collection("events").onSnapshot(snapshot => {
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);
      });

      // Sort our events based on time added
      data.sort((a, b) => (a.timestamp > b.timestamp) ? -1 : 1)

      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }
      // console.log(data);

      // Anytime the state of our database changes, we update state
      setData(data)
    })

  }



  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      ...getColumnSearchProps('date'),
      width: '20%',
      editable: false,
      sorter: (a, b) => { return a.date.localeCompare(b.date) },
    },
    {
      title: 'Event Title',
      dataIndex: 'title',
      editable: true,
    },
    {
      title: 'Event Images',
      dataIndex: 'unitno',
      width: '10%',
      editable: false,
      render: (text, record) => {
        const editable = isEditing(record);

        return (
          <div>
            <Button type="primary" ghost><Link to={'/dashboard/events/' + data[record.key].id + "/" + data[record.key].title}>Media</Link></Button>
          </div>
        );
      },
    },
    {
      title: '',
      width: '10%',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button
              href="javascript:;"
              onClick={() => save(record.key)}
              style={{
                marginRight: 8,
              }}
            >
              Save
          </Button>
            <Button type="primary" onClick={() => cancel(record.key)}>Cancel</Button>
          </span>
        ) : (
          <div>
            <Button disabled={editingKey !== ''} onClick={() => edit(record)}>
              Edit
        </Button>
            <Divider type="vertical" />

            <Popconfirm
              title="Confirm Delete?"
              onConfirm={evt => deleteEntry(record.key)}
            >
              <Button
                type="danger"
              >
                Delete
                </Button>
            </Popconfirm>

          </div>
        );
      },
    },
  ];

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
  }

  const handleReset = (clearFilters) => {
    clearFilters();
  }




  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'age' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <div>
      <h1 className="block">Events</h1>
      <div className="gutter-box">
        <DatePicker
          size="large"
          className="margin-row"
          format="DD-MM-YYYY"
          disabled={addingTodo}
          selected={pendingDate}
          onChange={handleChange}
          value={pendingDate}
        />
      </div>
      <div className="gutter-box">
        <Input
          className="gutter-box"
          size="large"
          placeholder="Title"
          disabled={addingEvent}
          onInput={evt => setPendingTitle(evt.target.value)}
          value={pendingTitle}
          required
        />
      </div>
      <div className="gutter-box">
        <Button
          className="App-add-todo-button"
          size="large"
          type="primary"
          onClick={addEvent}
          loading={addingEvent}
        >
          Add Event
      </Button>
      </div>




      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          bordered
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={{
            onChange: cancel,
          }}
        />
      </Form>
    </div>
  );
};

export default Events;



// WEBPACK FOOTER //
// ./src/views/events.js